<div
  class="pivot"
  style="position: absolute; background: red; width: 1em; height: 1em; border-radius: 100%; transform: translate(-50%, -50%)"
  [style.left.%]="100 * pivot()[0]"
  [style.top.%]="100 * pivot()[1]"
></div>
